import type {Facility} from 'api/facilities/facilities.types';

export const isExternallyManagedEventFacility = (
    facility?: Pick<Facility, 'productOfferings'>
): boolean => {
    const isExternalEventFacility = Boolean(
        facility?.productOfferings?.includes('external_events')
    );

    return isExternalEventFacility;
};

export const getEventFacilitySelection = (facilities: Facility[]) => {
    const selectedFacilities = facilities.filter(Boolean);
    const eligibleFacilities = selectedFacilities.filter(
        (facility) => !isExternallyManagedEventFacility(facility)
    );
    const hasExternalFacilities =
        eligibleFacilities.length < selectedFacilities.length;
    const allExternal =
        hasExternalFacilities && eligibleFacilities.length === 0;
    const isMixed = hasExternalFacilities && eligibleFacilities.length > 0;

    return {
        selectedFacilities,
        eligibleFacilities,
        hasExternalFacilities,
        allExternal,
        isMixed,
    };
};
